import { formatPercentage } from "@shared/utils/formatters/formatPercentage"
import { TripVehicle } from "../../api/insights"
import { VehicleData, VehicleScore, VehicleTotals } from "../types"
import { calculateScoreChange } from "../../utils"

export type InsightsVehicleData = {
  averageSpeedExceedencePercentage: string | null
  distanceSpentSpeeding: string | null
  currentPeriodDistance: number | null
  vehicle: VehicleData
  vehicleScore: VehicleScore
  vrn: string
  totals: VehicleTotals
  totalDistance: number | null
}

export const makeVehicleData = (vehicles: ReadonlyArray<TripVehicle>): ReadonlyArray<InsightsVehicleData> =>
  vehicles.map((vehicle) => ({
    averageSpeedExceedencePercentage: formatPercentage(vehicle.currentPeriod?.averageSpeedExceedencePercentage, 1),
    distanceSpentSpeeding: formatPercentage(vehicle.currentPeriod?.distanceSpentSpeeding, 1),
    currentPeriodDistance: vehicle.currentPeriod?.distance ?? null,
    totalDistance: vehicle.totalDistance,
    vrn: vehicle.vrn,
    vehicle: {
      vrn: vehicle.vrn,
      name: vehicle.name,
    },
    vehicleScore: {
      score: vehicle.currentPeriod?.score ?? null,
      change: calculateScoreChange(vehicle.currentPeriod?.score, vehicle.previousPeriodScore),
    },
    totals: {
      distance: vehicle.totalDistance,
      score: vehicle.totalSafetyScore,
    },
  }))
